import TioLoadingSpinner from 'tio-common/components/tio/loading-spinner';

<template>
  <div class="flex h-screen w-screen items-center justify-center">
    <TioLoadingSpinner />
  </div>
</template>
